/** Survives full page reload and OIDC redirects in the same tab (sessionStorage). */
const CHAT_SKIP_HYDRATE_KEY = 'wc.skip_chat_session_hydrate';

/** Call when the user leaves an authenticated session (logout, expiry, forced re-login). */
export function markSkipNextChatSessionHydrate(): void {
    try {
        sessionStorage.setItem(CHAT_SKIP_HYDRATE_KEY, '1');
    } catch {
        /* quota / private mode */
    }
}

/** Returns true once; clears the flag. Used so GET /chat/sessions is not restored after re-auth. */
export function consumeSkipNextChatSessionHydrate(): boolean {
    try {
        if (sessionStorage.getItem(CHAT_SKIP_HYDRATE_KEY) === '1') {
            sessionStorage.removeItem(CHAT_SKIP_HYDRATE_KEY);
            return true;
        }
    } catch {
        /* ignore */
    }
    return false;
}
